module.exports = __webpack_public_path__ + "static/media/Source Info.dd5024b5.txt";